import { Statistic } from "antd";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";

interface ITimeFromNowProps {
  date: string;
  title?: string;
}

const TimeFromNow: React.FC<ITimeFromNowProps> = ({ date, title }) => {
  const { t } = useTranslation();

  return (
    <Statistic
      className="statastics"
      title={title ? title : t("Created")}
      value={moment(date).fromNow()}
    />
  );
};

export default TimeFromNow;
